import { PhoneOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  message,
} from "antd";
import Link from "antd/es/typography/Link";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import OtpInput from "react-otp-input";
import { GreenButton } from "../../components/button/GreenButton";
import { Box } from "../../components/layout/box";
import { GuestLayout } from "../../components/layout/guest-layout";
import "./login.css";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

export const POST = async (path, data, header) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  try {
    const response = await instance.post(
      `/${path}`,
      data,
      header ? header : config,
    );
    data = await response.data;
    return data;
  } catch (error) {
    throw error.response;
  }
};

export default function Login() {
  const [otp, setOtp] = useState("");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(59);
  const [phonenum, setPhonenum] = useState("");
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };
  useEffect(() => {
    Cookies.remove("jwt");
    Cookies.remove("phone");
  }, []);

  const handleClearOTP = () => {
    setOtp("");
  };

  const [otp_authen, setOtpAuthen] = useState({
    otp_number: "",
    mobileNo: "",
  });

  const [mobile, setmobileNo] = useState({
    mobileNo: "",
  });

  const [cust_mobile, setcustmobileNo] = useState({
    cust_phone_number: "",
  });

  const [cookies, setCookie] = useCookies(["token"]);

  const mode = new URLSearchParams(window.location.search).get("mode");

  const [token, settoken] = useState("");

  const [ref, setRef] = useState("");

  useEffect(() => {
    if (otp.length == 6) {
      console.log(otp_authen.otp_number);
      POST("warranty/confirm_otp", otp_authen)
        .then((response) => {
          if (response.data[0].Result === "true") {
            setPhonenum("true");
            settoken(response.token);
          } else {
            alert("OTP ไม่ถูกต้อง (OTP อาจหมดอายุแล้ว)");
            setOtp("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [otp]);

  useEffect(() => {
    if (token) {
      setTokenCookie(token, cust_mobile.cust_phone_number);
      console.log(token);
    }
  }, [token]);

  const setTokenCookie = (data, phone) => {
    setCookie("jwt", data, { path: `/` });
    setCookie("phone", phone, { path: `/` });
  };

  const sendotp = async () => {
    setMinutes(0);
    setSeconds(59);
    const firstTwoDigits = mobile.mobileNo.slice(0, 2);
    if (
      mobile.mobileNo.length == 10 &&
      (firstTwoDigits === "08" ||
        firstTwoDigits === "06" ||
        firstTwoDigits === "09")
    ) {
      setIsModalOpen(true);
      await POST("warranty/send_otp", mobile)
        .then((response) => {
          console.log("ressss", response.ref);
          setRef(response.ref);
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (mobile.mobileNo.length > 10) {
      message.open({
        type: "error",
        content: "กรอกเบอร์โทรศัพท์เกิน",
        className: "custom-class",
        style: {
          marginTop: "8vh",
          fontSize: "16px",
        },
      });
    } else if (mobile.mobileNo.length < 10) {
      message.open({
        type: "error",
        content: "กรุณากรอกเบอร์โทรศัพท์ให้ครบถ้วน",
        className: "custom-class",
        style: {
          marginTop: "8vh",
          fontSize: "16px",
        },
      });
    } else {
      message.open({
        type: "error",
        content: "กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง",
        className: "custom-class",
        style: {
          marginTop: "8vh",
          fontSize: "16px",
        },
      });
    }
  };

  const OtpValidate = (e) => {
    setOtp(e);
    setOtpAuthen({
      ...otp_authen,
      otp_number: e,
      mobileNo: mobile.mobileNo,
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const datainputChange = (e) => {
    setmobileNo({
      ...mobile,
      [e.target.name]: e.target.value,
    });
    setcustmobileNo({
      ...cust_mobile,
      cust_phone_number: e.target.value,
    });
  };

  useEffect(() => {
    if (phonenum) {
      if (phonenum == "true") {
        // setTokenCookie(token);
        POST("warranty/register/search_phone_num/", cust_mobile)
          .then((response) => {
            if (response[0].is_found == "true") {
              window.location = `/register-warranty/order_list/${cust_mobile.cust_phone_number}?mode=${mode}`;
            } else {
              window.location = `/register-warranty/register/${cust_mobile.cust_phone_number}?mode=${mode}`;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [phonenum]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  return (
    <GuestLayout title={"ยืนยันตัวตน"}>
      <div className="textinput">
        <div className="subtextinput">
          <h1 style={{ textAlign: "center", fontSize: "22px" }}>
            กรุณายืนยันตัวตน <br></br>
            <b style={{ fontSize: "20px" }}>Please Verify Your Mobile No.</b>
          </h1>
          <p style={{ textAlign: "center", fontSize: "14px" }}>
            โปรดระบุหมายเลขโทรศัพท์มือถือของท่าน เพื่อรับรหัส OTP ทาง SMS
          </p>
          <Form layout="vertical" className="Form">
            {/* <Form.Item label="เบอร์โทรศัพท์มือถือ (Mobile No.)" > */}
            <Form.Item>
              <Input
                prefix={<PhoneOutlined style={{ color: "#a9a9a9" }} />}
                placeholder="เบอร์โทรศัพท์มือถือ (Mobile No.)"
                type="text"
                value={mobile.mobileNo}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/\D/g, "");
                  const truncatedValue = inputValue.slice(0, 10);
                  datainputChange({
                    target: { name: "mobileNo", value: truncatedValue },
                  });
                }}
                name="mobileNo"
              />
            </Form.Item>
            <Form.Item>
              <GreenButton block type="submit" onClick={sendotp}>
                รับรหัส OTP
              </GreenButton>
            </Form.Item>
          </Form>
        </div>

        <Modal
          title="ยืนยัน OTP"
          open={isModalOpen}
          onCancel={handleCancel}
          footer={[
            // <Button onClick={handleCancel} >
            //   cancel
            // </Button>,
            <div style={{ textAlign: "center" }}>
              {seconds > 0 || minutes > 0 ? (
                <p>
                  หากไม่ได้รับ OTP สามารถส่งใหม่ได้อีกครั้งใน{" "}
                  {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
              ) : (
                <p>หากไม่ได้รับ OTP สามารถส่งใหม่ได้อีกครั้ง</p>
              )}
            </div>,
            <Button onClick={handleClearOTP}>ล้างค่า</Button>,
            <Button disabled={seconds > 0 || minutes > 0} onClick={sendotp}>
              ส่งใหม่
            </Button>,
          ]}
        >
          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <div>
              OTP ที่ได้รับมีอายุการใช้งาน 5 นาที <br></br>(รหัสอ้างอิง: {ref})
            </div>
            <div className="otpmodal">
              <OtpInput
                value={otp}
                onChange={OtpValidate}
                inputType={"number"}
                numInputs={6}
                inputStyle={{
                  borderRadius: "5px",
                  width: "100%",
                  height: "100%",
                  fontSize: "16px",
                }}
                renderSeparator={<span>&nbsp;&nbsp;&nbsp;</span>}
                renderInput={(props) => <input {...props} />}
                shouldAutoFocus={true}
                containerStyle="otp-container"
                className="otp-input"
              />
            </div>
          </Space>
        </Modal>
      </div>
    </GuestLayout>
  );
}
